import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DataTable, { createTheme } from 'react-data-table-component';
import dateFormat from "dateformat";
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import AdminLayout from '../../layout/AdminLayout';
import { apiError } from '../../../helpers/ErrorHelper';
import { get, put, post, setAuthToken, del } from '../../../config/ApiConfig';
import { tableCustomLoader } from '../../../helpers/StyleHelper';
import { useAuth } from '../../../context/AuthContext';
import { leaveApplicationStatus, leaveDates } from '../../../helpers/LeaveHelper';
import { checkPermission, profilePic } from '../../../helpers/GeneralHelper';
import { useTheme } from '../../../context/ThemeContext';
import { getLeaveApplications } from '../../../models/LeaveModel';
import LeaveApplicationTables from '../../tables/LeaveApplicationTables';
import ApplyLeaveModal from '../../modals/Leave/ApplyLeaveModal';
import ViewLeaveApplicationModal from '../../modals/Leave/ViewLeaveApplicationModal';
import { useNotificationCount } from '../../../context/NotificationCountContext';
import Error403 from '../Error403';


function LeaveApplications() {

    const { notificationCount, setNotificationCount } = useNotificationCount();

    const { theme, toggleTheme } = useTheme();

    const { state } = useAuth(); 

    let user_data = state.user_data;
  
    const navigate = useNavigate();  
  
    const loader = document.getElementById('loading');

    const [modalKey, setModalKey] = useState(0);

    //Apply Leave Start
    const [showApplyLeaveModal, setShowApplyLeaveModal] = useState(false);
    //Apply Leave End


    //View Leave Start
    const [showViewLeaveModal, setShowViewLeaveModal] = useState(false);

    const [applicationData, setApplicationData] = useState({});

    const openViewApplicationModal = (leave_data) =>{
        setApplicationData(leave_data);
        setModalKey(prevKey => prevKey + 1);
        setShowViewLeaveModal(true);
    }  
    //View Leave End

    //Flush Application Start
    const flushApplication = async() => {
        localStorage.removeItem("leave_applications");
        fetchApplications(limit, page); 
    }  
    //Flush Application End

    //Application List Start 
    const [data, setData] = useState([]);
    const [cacheTime, setCacheTime] = useState([]);
    const [loading, setLoading] = useState(true);
    const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);

    const fetchApplications = async(newLimit, page) => {
        setLoading(true);
    
        try {
            let apiParam = {page: page, limit: newLimit, user_token: user_data.user_token};

            const response = await getLeaveApplications(apiParam);

            if (typeof response != typeof undefined) {
                setData(response.applications);
                setTotalRows(response.pagination.total_rows);
                setLimit(newLimit);
                setPage(page);

                if (response.time) {
                    setCacheTime(response.time);
                }

                setNotificationCount(localStorage.getItem('unread_notification_count'));
            }
            else{
                navigate('/re-login');
            }    
            setLoading(false);
    
        } catch (error) {
            //console.error(error);
        }
    
        
    };
    //Application List End 

    
    
  return (
    <>
        {checkPermission('menu_leave')===true ? (
        <AdminLayout>
        
            <Helmet>
                <title>Leave Applications - Worktracker Anciletech</title>
                
            </Helmet>

            <div className="main-content app-content">

                
                <div className="container-fluid">

                    {/* <!-- Page Header --> */}
                    <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
                        <h1 className="page-title fw-semibold fs-18 mb-0">Leave Applications</h1>
                        <div className="ms-md-1 ms-0">
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item"><a href="javascript:void(0);">Dashboard</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">Leave Applications</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    {/* <!-- Page Header Close --> */}

                    {/* <!-- Start::row-1 --> */}
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="card custom-card">
                                <div className="card-header d-flex align-items-center justify-content-between flex-wrap gap-3">
                                    <div className="card-title">
                                        Last Synced On {cacheTime}
                                    </div>

                                    <div className="d-flex flex-wrap gap-2">
                                        <button className="btn btn-primary btn-sm" onClick={() => setShowApplyLeaveModal(true)}>
                                            <i className="ri-add-line me-1 fw-semibold align-middle"></i>Apply Leave
                                        </button>

                                        <button className="btn btn-success-light btn-sm" onClick={() => flushApplication()}>
                                            <i className="ri-refresh-line me-1 fw-semibold align-middle"></i>Refresh
                                        </button>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <LeaveApplicationTables 
                                          data={data}
                                          setData={setData}
                                          loading={loading}
                                          setLoading={setLoading}
                                          totalRows={totalRows}
                                          setTotalRows={setTotalRows}
                                          page={page}
                                          setPage={setPage}
                                          limit={limit}
                                          setLimit={setLimit}
                                          fetchApplications={fetchApplications}
                                          openViewApplicationModal={openViewApplicationModal} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!--End::row-1 --> */}


                    {/* <!--Apply Leave Modal Start--> */}
                    <ApplyLeaveModal
                    showModal={showApplyLeaveModal}
                    setShowModal={setShowApplyLeaveModal}
                    fetchApplications={fetchApplications}
                    limit={limit}
                    page={page} />
                    {/* <!--Apply Leave Modal End--> */}


                    {/* <!--View Leave Modal Start--> */}
                    <ViewLeaveApplicationModal
                    showModal={showViewLeaveModal}
                    setShowModal={setShowViewLeaveModal}
                    applicationData={applicationData}
                    modalKey={modalKey}
                    fetchApplications={fetchApplications}
                    limit={limit}
                    page={page} />
                    {/* <!--View Leave Modal End--> */}


                </div>


            </div>  

            <Helmet>
                
            </Helmet>
        
        </AdminLayout>
        ) : ( <Error403/>)}
    </>
  )
}

export default LeaveApplications
